import { useFormik } from 'formik'
import { confiUrl } from './tekenConfig'
import { useContext } from 'react'
import TokenContext from './TokenContext'

export const EditForm = ({ initialValues = {}, afterSave }) => {
  const token = useContext(TokenContext)
  const fieldDefs = [
    { label: 'Apartment number', id: 'Apartment_number__c' },
    { label: 'City ', id: 'City__c' },
    { label: 'Country ', id: 'Country__c' },
    { label: 'Email ', id: 'Email__c ' },
    { label: 'Email bis ', id: 'Email_bis__c' },
    { label: 'End date ', id: 'End_date__c' },
    { label: 'Full address ', id: 'Full_address__c' },
    { label: 'Latitude ', id: 'Latitude__c' },
    { label: 'Longitude ', id: 'Longitude__c' },
    { label: 'Number of closed rooms ', id: 'Number_of_closed_rooms__c' },
    { label: 'Province ', id: 'Province__c', },
    { label: 'Rent price (monthly) ', id: 'Rent_price_monthly__c' },
    { label: 'Start date ', id: 'Start_date__c' },
    // { label: 'Status ', id: 'Status__c' },
    { label: 'Street name ', id: 'Street_name__c' },
    { label: 'Street number ', id: 'Street_number__c' },
    { label: 'Year ', id: 'Year__c' },
    { label: 'Zip code ', id: 'Zip_code__c' },
  ]
  const formik = useFormik({

    initialValues,

    onSubmit: values => {
      //      alert(JSON.stringify(values, null, 2))
    delete values.attributes
      fetch(`${confiUrl.RENTS_URL}?token=${token}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          payload: JSON.stringify({
            token,
            rents: [values]
          })
        })
      }).then(r => {
        console.log ('saved', r)
        if(r.status<300){
          alert('saved')
          if(afterSave){
            afterSave()
          }
        }else{
          alert('got error')
        }
      })


    },

  })
  return <div>
    <form onSubmit={formik.handleSubmit}>
      {fieldDefs.map((item) => {
        return <div key={item.id}>
          <label htmlFor={item.id}>{item.label}</label>
          <input
            id={item.id}
            name={item.id}
            type="text"
            onChange={formik.handleChange}
            value={formik.values[item.id]}
          />
        </div>
      })}

      <button type="submit">Save</button>
    </form>

  </div>
}